import { render, staticRenderFns } from "./SsrRoot.vue?vue&type=template&id=bd5e39ba"
import script from "./SsrRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./SsrRoot.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports